(function () {
  var root = document.querySelector('[data-sd-cookie-consent]');

  if (!root || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
    return;
  }

  var dialog = root.querySelector('.sd-cookie-consent__dialog');
  var analyticsToggle = root.querySelector('[data-sd-cookie-toggle="analytics"]');
  var preferencesToggle = root.querySelector('[data-sd-cookie-toggle="preferences"]');
  var marketingToggle = root.querySelector('[data-sd-cookie-toggle="marketing"]');
  var requiredButton = root.querySelector('[data-sd-cookie-required]');
  var allButton = root.querySelector('[data-sd-cookie-all]');
  var saveButton = root.querySelector('[data-sd-cookie-save]');
  var errorMessage = root.querySelector('[data-sd-cookie-error]');
  var initialFocus = null;
  var forceOpen = false;

  try {
    var queryParameters = new URLSearchParams(window.location.search);
    forceOpen = queryParameters.has('sd_cookie_debug');
  } catch (error) {
    forceOpen = false;
  }

  function boolFromConsent(value) {
    return value === true || value === 'yes';
  }

  function currentConsent(customerPrivacy) {
    if (!customerPrivacy || typeof customerPrivacy.currentVisitorConsent !== 'function') {
      return {};
    }

    try {
      return customerPrivacy.currentVisitorConsent() || {};
    } catch (error) {
      return {};
    }
  }

  function hasStoredChoice(consent) {
    return ['analytics', 'preferences', 'marketing'].some(function (key) {
      return consent[key] === 'yes' || consent[key] === 'no' || typeof consent[key] === 'boolean';
    });
  }

  function syncToggles(consent) {
    if (analyticsToggle) {
      analyticsToggle.checked = boolFromConsent(consent.analytics);
    }

    if (marketingToggle) {
      marketingToggle.checked = boolFromConsent(consent.marketing);
    }

    if (preferencesToggle) {
      preferencesToggle.checked = boolFromConsent(consent.preferences);
    }
  }

  function setOpen(isOpen) {
    root.hidden = !isOpen;
    document.body.classList.toggle('sd-cookie-consent-open', isOpen);

    if (isOpen) {
      if (errorMessage) {
        errorMessage.hidden = true;
      }

      initialFocus = document.activeElement;
      window.setTimeout(function () {
        if (dialog) {
          dialog.focus();
        }
      }, 0);
      return;
    }

    if (initialFocus && typeof initialFocus.focus === 'function') {
      initialFocus.focus();
    }
  }

  function pushDataLayer(consent) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'sd_cookie_consent_update',
      consent_analytics: consent.analytics,
      consent_preferences: consent.preferences,
      consent_marketing: consent.marketing
    });
  }

  function setConsent(customerPrivacy, consent) {
    var payload = {
      analytics: Boolean(consent.analytics),
      marketing: Boolean(consent.marketing),
      preferences: Boolean(consent.preferences)
    };

    if (!customerPrivacy || typeof customerPrivacy.setTrackingConsent !== 'function') {
      setOpen(false);
      return;
    }

    customerPrivacy.setTrackingConsent(payload, function (result) {
      if (result && result.error) {
        if (errorMessage) {
          errorMessage.hidden = false;
        }
        return;
      }

      pushDataLayer(payload);
      setOpen(false);
    });
  }

  function selectedConsent() {
    return {
      analytics: analyticsToggle ? analyticsToggle.checked : false,
      preferences: preferencesToggle ? preferencesToggle.checked : false,
      marketing: marketingToggle ? marketingToggle.checked : false
    };
  }

  function shouldShow(customerPrivacy) {
    if (forceOpen) {
      return true;
    }

    var consent = currentConsent(customerPrivacy);

    if (hasStoredChoice(consent)) {
      return false;
    }

    if (typeof customerPrivacy.shouldShowBanner === 'function') {
      try {
        if (customerPrivacy.shouldShowBanner()) {
          return true;
        }
      } catch (error) {
        return true;
      }
    }

    return true;
  }

  function trapKeyboard(event) {
    if (event.key === 'Escape' && !root.hidden) {
      event.preventDefault();
      return;
    }

    if (event.key !== 'Tab' || root.hidden || !dialog) {
      return;
    }

    var focusable = dialog.querySelectorAll(
      'a[href], button:not([disabled]):not([hidden]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
    );

    if (!focusable.length) {
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1'
      }
    ],
    function (error) {
      if (error || !window.Shopify.customerPrivacy) {
        return;
      }

      var customerPrivacy = window.Shopify.customerPrivacy;
      syncToggles(currentConsent(customerPrivacy));

      if (shouldShow(customerPrivacy)) {
        setOpen(true);
      }

      root.querySelectorAll('.sd-cookie-consent__switch').forEach(function (switchElement) {
        switchElement.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      });

      root.addEventListener('change', function (event) {
        if (event.target && event.target.matches('[data-sd-cookie-toggle]')) {
          saveButton.hidden = false;
          allButton.hidden = true;
        }
      });

      requiredButton.addEventListener('click', function () {
        if (analyticsToggle) {
          analyticsToggle.checked = false;
        }

        if (marketingToggle) {
          marketingToggle.checked = false;
        }

        if (preferencesToggle) {
          preferencesToggle.checked = false;
        }

        setConsent(customerPrivacy, { analytics: false, preferences: false, marketing: false });
      });

      allButton.addEventListener('click', function () {
        if (analyticsToggle) {
          analyticsToggle.checked = true;
        }

        if (marketingToggle) {
          marketingToggle.checked = true;
        }

        if (preferencesToggle) {
          preferencesToggle.checked = true;
        }

        setConsent(customerPrivacy, { analytics: true, preferences: true, marketing: true });
      });

      saveButton.addEventListener('click', function () {
        setConsent(customerPrivacy, selectedConsent());
      });

      document.addEventListener('click', function (event) {
        var opener = event.target && event.target.closest ? event.target.closest('[data-sd-cookie-open], a[href="#cookie-settings"]') : null;

        if (!opener) {
          return;
        }

        event.preventDefault();
        syncToggles(currentConsent(customerPrivacy));
        saveButton.hidden = false;
        allButton.hidden = true;
        setOpen(true);
      });

      document.addEventListener('keydown', trapKeyboard);
    }
  );
})();
